var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.875 7.75C12.875 10.8566 10.3566 13.375 7.25 13.375C4.1434 13.375 1.625 10.8566 1.625 7.75C1.625 4.6434 4.1434 2.125 7.25 2.125C10.3566 2.125 12.875 4.6434 12.875 7.75ZM11.6494 13.0333C10.4572 14.0271 8.92343 14.625 7.25 14.625C3.45304 14.625 0.375 11.547 0.375 7.75C0.375 3.95304 3.45304 0.875 7.25 0.875C11.047 0.875 14.125 3.95304 14.125 7.75C14.125 9.42344 13.5271 10.9572 12.5333 12.1494L16.4419 16.0581C16.686 16.3021 16.686 16.6979 16.4419 16.9419C16.1978 17.186 15.8021 17.186 15.558 16.9419L11.6494 13.0333Z",
    fill: "#515151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSearchIcon);
export default __webpack_public_path__ + "static/media/newSearchIcon.4eec5867.svg";
export { ForwardRef as ReactComponent };